﻿/* eslint-disable vue/sort-keys */
import axios from 'axios';
import jQuery from 'jquery';
import { camelCase, isPlainObject } from 'lodash';

class Utility {
  constructor() {}

  static domain() {
    if (this.isStatic()) {
        return 'http://dev-minside.lb.dk';
    }
    
    return window.location.origin;
  }

  static constants() {
    return {
      ANIMATION: {
        duration: {
          slideToggle: 200,
          scrollTo: 1
        }
      },
      API: {
        proposal_save_input: '',
        proposal_get_input: `${this.domain()}/api/proposal/getproposal/`,
        proposal_get_price: `${this.domain()}/api/policy/saveproposal/`,
        proposal_calculate_price: `${this.domain()}/api/proposal/calculateprice/`,
        proposal_save_proposal: `${this.domain()}/api/policy/saveproposal/`,
        proposal_save_to_basket: `${this.domain()}/api/proposal/savetobasket/`,
        proposal_get_basket: `${this.domain()}/api/proposal/getbasket/`,
        proposal_remove_from_basket: `${this.domain()}/api/proposal/removefrombasket/`,
        Proposal_update_paymentrate: `${this.domain()}/api/proposal/updatepaymentrate/`,
        proposal_update_paymentfrequency: `${this.domain()}/api/proposal/edit/paymentfrequency/`,
        policy_calculate_price: `${this.domain()}/api/policy/calculateprice/`,
        policy_save: `${this.domain()}/api/policy/save/`,
        policy_get: `${this.domain()}/api/policy/get/`,
        policy_edit_initiate: `${this.domain()}/api/policy/edit/initiate/`,
        policy_edit_update_amount_reference: 'api/policy/edit/update/amount/reference',
        policy_edit_add: 'api/policy/edit/add',
        policy_edit_remove: 'api/policy/edit/remove',
        policy_edit_cover: 'api/policy/edit/update/cover',
        policy_edit_amount: 'api/policy/edit/update/amount',
        policy_edit_save: 'api/policy/edit/save',
        policy_edit_clear: `${this.domain()}/api/policy/edit/clear`,
        policy_edit_cancel: `${this.domain()}/api/policy/edit/cancel`,
        marketing_permission_save: `${this.domain()}/api/marketingpermission/update`,
        checkout_save_proposal: `${this.domain()}/api/checkout/`,
        checkout_save_payment: `${this.domain()}/api/checkout/complete`,
        checkout_ping: `${this.domain()}/api/checkout/ping`,
        error_log: `${this.domain()}/api/logging/log`,
        campaignbox: `${this.domain()}/api/campaignbox/get/`,
        campaign_response_order_get: `${this.domain()}/api/campaignresponseorder/get/`,
        campaign_response_order_submit_get: `${this.domain()}/api/campaignresponseordersubmit/get/`,
        campaign_response_order_submit_complete: `${this.domain()}/api/campaignresponseordersubmit/complete/`,
        createclaim_getquestionnaire: `${this.domain()}/api/createclaim/getquestionnaire`,
        createclaim_create: `${this.domain()}/api/createclaim/create`,
        createclaim_upload: `${this.domain()}/api/createclaim/upload`,
        claimsection_member_considered_all_tasks: `${this.domain()}/api/claims/memberconsideredalltasks`,
        claimsection_upload: `${this.domain()}/api/claims/upload`,
        claimsection_upload_with_documentation: `${this.domain()}/api/claims/uploadwithdocumentation`,
        claimsection_no_documentation: `${this.domain()}/api/claims/nodocumentation`,
        claimsection_persist_documentation_requirement_list: `${this.domain()}/api/claims/persistdocumentationrequirementlist`,
        claimsection_renewscalepointmodel: `${this.domain()}/api/createclaim/renewscalepointmodel`,
        quick_quote_flow_save: `${this.domain()}/api/quickquote/`, // This is only first part of the api link. Full link example: this.domain/api/Proposal/content/save
        proposal_flow_vehicle: `${this.domain()}/api/vehicle/`,
        get_repair_shops: `${this.domain()}/api/createclaim/getrepairshops`,
        proposal_awaiting_approval: `${this.domain()}/api/proposal/awaiting/get/`,
        proposal_fetch_covers: `${this.domain()}/api/Proposal/fetchcovers`,
        proposal_clear_asset: `${this.domain()}/api/Proposal/clearasset`,
        proposal_moped_search: `${this.domain()}/api/checkout/moped/search`,
        proposal_caravan_search: `${this.domain()}/api/checkout/caravan/search`,
        power_of_attorney_create: `${this.domain()}/api/powerofattorney/create`,
        power_of_attorney_update: `${this.domain()}/api/powerofattorney/update`,
        quickquote_add_cover: `${this.domain()}/api/quickquote/cover/add`,
        quickquote_update_cover: `${this.domain()}/api/quickquote/cover/updatecoveramount`,
        quickquote_remove_cover: `${this.domain()}/api/quickquote/cover/remove`,
        quickquote_update_single_contact_cpr: `${this.domain()}/api/quickquote/updatecontactcprnumber`,
        quickquote_visitstep2: `${this.domain()}/api/quickquote/visitsteptwo`,
        quickquote_readyforbasket: `${this.domain()}/api/quickquote/readyforbasket`,
        quickquote_convert: `${this.domain()}/api/quickquote/convertquickquotes`,
        quickquote_convert_single: `${this.domain()}/api/quickquote/convertquickquote`,
        quickquote_validate_single: `${this.domain()}/api/quickquote/validatequickquote`,
        quickquote_conversionstatus: `${this.domain()}/api/quickquote/conversionstatus`,
        // proposal_change_insurancesum: `${this.domain()}/api/quickquote/cover/updateinsurancesum`,
        // proposal_change_deductible: `${this.domain()}/api/quickquote/cover/updatedeductible`,
        quickquote_delete: `${this.domain()}/api/quickquote/basket/delete`,
        quickquote_study: `${this.domain()}/api/studyinsurance`,
        quickquote_study_calculate: `${this.domain()}/api/studyinsurance/calculate`,
        quickquote_study_submit: `${this.domain()}/api/studyinsurance/submit`,
        quickquote_changegroupedcover: `${this.domain()}/api/quickquote/cover/changegroupedcover`,
        quickquote_ready: `${this.domain()}/api/quickquote/readyforconversion`,
        proposal_delete: `${this.domain()}/api/basket/delete`,
        proposal_get_all: `${this.domain()}/api/proposal/getProposals`,
        poa_impersonation: `${this.domain()}/api/impersonation/setself`,
        poa_impersonation_cancle: `${this.domain()}/api/impersonation/CancelImpersonation `,
        travel_letter_create: `${this.domain()}/api/travelletter/create`,
        keep_alive_claim_creation: `${this.domain()}/api/createclaim/keepaliveclaimcreation`,
        keep_alive_session: `${this.domain()}/api/keepalive/session`,
        timeout_logout: `${this.domain()}/api/member/timeoutlogout`,
        cpr_consent: `${this.domain()}/api/cprconsent/get/`,
        cpr_consent_submit: `${this.domain()}/api/cprconsent/submit`,
        payout_form: `${this.domain()}/api/payoutform/submit`,
        upload_document_taxation: `${this.domain()}/api/Checkout/uploaddocument?flowType=taxation`,
        motorist_plus_enroll: `${this.domain()}/api/motoristplus/enrollmotoristplus`,
        green_card_order: `${this.domain()}/api/greenredcard/getcard`,
        hasscalepointloss: `${this.domain()}/api/createclaim/hasscalepointloss`,
        ranked_search: `${this.domain()}/api/search/performrankedsearch`,
        weighted_search: `${this.domain()}/api/search/performweightedsearch`,
        typeahead_search: `${this.domain()}/api/search/performtypeahead`,
        visitor_search: `${this.domain()}/api/search/visitorsearch`,
        imagewithlink_get: `${this.domain()}/api/imagewithlink/get/`,
        marketingpermission_get: `${this.domain()}/api/marketingpermission/getNonModal`,
        marketingpermission_post: `${this.domain()}/api/marketingpermission/decline`,
        marketingpermission_decline: `${this.domain()}/api/marketingpermission/decline`,
        policieswithoutpaymentagreement: `${this.domain()}/api/policieswithoutpaymentagreement/get`,
        policieswithoutpaymentagreementPost: `${this.domain()}/api/policieswithoutpaymentagreement/post`,
        bike_theft_claim_flow_initiate: `${this.domain()}/api/createclaimbicycle/initiate`,
        bike_theft_claim_flow_create: `${this.domain()}/api/createclaimbicycle/create`,
        bike_theft_claim_flow_upload: `${this.domain()}/api/createclaimbicycle/upload`,
        trustpilot_get: `${this.domain()}/api/trustpilot/get`,
        topbanner_get: `${this.domain()}/api/topbanner/get`,
        marketingBox_get: `${this.domain()}/api/quickquote/marketingBox/step`,
        logofooter: `${this.domain()}/api/logofooter/get/`,
        navigation_list: `${this.domain()}/api/navigationlist/get/`,
        newsletter_signup_main: `${this.domain()}/api/newslettersignupbyemail/get/`,
        newsletter_signup_submit: `${this.domain()}/api/newslettersignupbyemail/submit/`,
        claimoverview: `${this.domain()}/api/claim/overview/get/`,
        member_isloggedin_newmember: `${this.domain()}/api/member/getisloggedinmembernewmember`,
        claimDmrLookup: `${this.domain()}/api/createclaim/lookupdmr?licenseplate=`,
        partnership_referral_get: `${this.domain()}/api/PFAPartnership/get`,
        partnership_referral_submit: `${this.domain()}/api/PFAPartnership/submit`,
        nba_get: `${this.domain()}/api/nba/get/`,
        topstory_get: `${this.domain()}/api/topstory/get`,
        loyality_reward_get: `${this.domain()}/api/loyalityreward/get`,
        basket_get: `${this.domain()}/api/basket/get`,
        popup_get: `${this.domain()}/api/popup/get`,
        callme_get: `${this.domain()}/api/callme/get`,
        callmebanner_get: `${this.domain()}/api/callmebanner/get`,
        salesforce_timeslots_get: `${this.domain()}/api/lead/timeslots`,
        lead_submit: `${this.domain()}/api/lead/submit`,
        alert_get: `${this.domain()}/api/alert/get`,
        basket_products: `${this.domain()}/api/basket/products`,
        sitecore_search: `${this.domain()}/api/publicportalsearch/searchresults`,
        sitecore_search_event_click: `${this.domain()}/api/publicportalevent/click`,
        sitecore_search_event_view: `${this.domain()}/api/publicportalevent/view`,
        green_card_for_pdf_get: `${this.domain()}/api/greencardforpdf/get/`,
        personal_assistance_get: `${this.domain()}/api/personalassistance/get`,
      },
      externalAPI: {
        dawa_adgangsadresser: 'https://dawa.aws.dk/adgangsadresser/autocomplete?q=',
        dawa_adresser: 'https://dawa.aws.dk/adresser/autocomplete?q='
      },
      DATETIME: {
        months: [
          'Januar',
          'Februar',
          'Marts',
          'April',
          'Maj',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'December'
        ]
      },
      SCROLLING: {
        flowPageDefaultOffset: 160
      }
    };
  }

  static getBrand() {
    const url = location.hostname;
    if (url.indexOf('runa') > -1) {
      return ['runa', '#641F19'];
    }
    if (url.indexOf('bauta') > -1) {
      return ['bauta', '#426A56'];
    }
    if (url.indexOf('pfa') > -1) {
      return ['pfa', '#000562'];
    }
    return ['lb', '#5692B5'];
  }

  static getLanguageIdentifier() {
    if (window.location.pathname === '/english') {
      return 'en';
    }

    return 'da';
  }

  static getBrandIdentifier() {
    return window.location.hostname.split('.')[1];
  }

  static getBrandSiteUrl() {
    return 'https://www.' + this.getBrandIdentifier() + '.dk';
  }

  static isLiveSite() {
    const url = location.hostname;
    const testOrPreStrings = [
      'dev-minside', // development portal pages
      'local', // development public pages
      'tt', // test sites (shared between public and portal pages)
      'ct', // test sites (shared between public and portal pages)
      'qa', // staging sites (shared between public and portal pages)
      'preprod'
    ]; // staging sites (shared between public and portal pages)

    var result = !testOrPreStrings.some((el) => url.includes(el));
    return result;
  }

  static throttle(action) {
    let isRunning = false;
    return function () {
      if (isRunning) {
        return;
      }
      isRunning = true;
      window.requestAnimationFrame(() => {
        action();
        isRunning = false;
      });
    };
  }

  static scrollToElem(elem, offset = 0) {
    // console.log('scrollToElem', elem, offset);
    if (elem.length < 1) {
      return;
    }

    let scrollElm = elem;

    if (!(elem instanceof jQuery)) {
      scrollElm = $(elem);
    }

    if(!scrollElm.offset())
      return;

    return $('html, body').animate(
      {
        scrollTop: scrollElm.offset().top - offset
      },
      800
    );
  }

  static nextTickScroll(elementId, vm, offset = 50) {
    vm.$nextTick(() => this.scrollToElem($(elementId), offset));
  }

  static logError(error, vm, callback) {
    // console.log('VUE ERROR:', error);
    let message = error;
    let vmName = '';

    if (error.message !== undefined) {
      message = error.message;
    }

    if (
      typeof vm !== 'undefined' &&
      typeof vm.$options !== 'undefined' &&
      typeof vm.$options.name !== 'undefined'
    ) {
      vmName = vm.$options.name;
    }

    axios
      .post(
        this.constants().API.error_log,
        this.createFrontendErrorLogData(
          'Error',
          window.userId,
          message,
          vmName,
          null,
          window.location.href,
          null,
          null
        )
      )
      .then(() => {
        if (callback) {
          callback();
        }
      })
      .catch(() => {
        if (callback) {
          callback();
        }

        return false;
      });
  }

  static getQueryVariable(variable) {
    if (window.location.search === undefined) {
      return false;
    }

    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return false;
  }

  static getQueryVariableFromRouterUrl(variableName) {
    const hash = window.location.href;
    const queryParams = hash.split('?')[1];
    const queryParamsList = queryParams.split('&');
    const value = queryParamsList.find((param) => {
      const parameterSplit = param.split('=');
      const parameterName = parameterSplit[0];

      return parameterName === variableName;
    });

    if (value !== undefined) {
      return value.split('=')[1];
    }

    return '';
  }

  static mediaQueries() {
    return {
      smallOnly: window.matchMedia('screen and (max-width: 39.9375em)'),
      mediumUp: window.matchMedia('screen and (min-width: 40em)'),
      mediumOnly: window.matchMedia('screen and (min-width: 40em) and (max-width: 63.9375em)'),
      largeUp: window.matchMedia('screen and (min-width: 64em)'),
      largeOnly: window.matchMedia('screen and (min-width: 64em) and (max-width: 74.9375em)')
    };
  }

  static mq() {
    return {
      isSmallOnly: this.mediaQueries().smallOnly.matches,
      isMediumUp: this.mediaQueries().mediumUp.matches,
      isMediumOnly: this.mediaQueries().mediumOnly.matches,
      isLargeUp: this.mediaQueries().largeUp.matches,
      isLargeOnly: this.mediaQueries().largeOnly.matches
    };
  }

  static getScrollOffset(onLoad) {
    let offset;
    const bodyElem = $('body');

    // mobile
    offset = 50;

    // desktop
    if (onLoad && this.mq().isLargeUp) {
      offset = 180;
    }

    if (!onLoad && this.mq().isLargeUp) {
      offset = 110;
    }

    if (!onLoad && this.mq().isLargeUp && $(document).scrollTop() === 0) {
      offset = 180;
    }

    if (this.searchBarVisible) {
      offset += 55;
    }

    const alertElement = document.querySelector('section.alert-banner');
    // Might be something to fix here
    const headerElement = document.querySelector('header.header-container');
    if (headerElement !== null && alertElement !== null && headerElement.contains(alertElement)) {
      const alertElementHeight = alertElement.offsetHeight;
      offset += alertElementHeight;
    }

    offset += bodyElem.hasClass('power-of-attorney') ? 70 : 0;

    return offset;
  }

  static hasHash() {
    return window.location.hash && window.location.hash.indexOf('/') === -1;
  }

  static leadingZero(val) {
    return ('0' + val).slice(-2);
  }

  static getRoundedTime(date) {
    return (
      this.leadingZero(date.getHours()) +
      ':' +
      this.leadingZero(Math.floor(date.getMinutes() / 15) * 15)
    );
  }

  static isStatic() {
    const loc = window.location.origin;

    if (loc === undefined) {
      return;
    }

    if (loc.indexOf('127.0.0.1') > 0 || loc.indexOf('localhost') > 0) {
      return true;
    }

    return false;
  }

  static getBrandFolderName() {
    if (this.isStatic()) {
      return 'lb';
    }

    return window.location.origin.split('.')[1];
  }

  static birthDateStartDate() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 17);
    return date;
  }

  static dateRangeForBirthDateDatePickers() {
    const maxYear = this.birthDateStartDate().getFullYear();
    const minYear = maxYear - 80;
    return [minYear, maxYear];
  }

  static createFrontendErrorLogData(
    type,
    user,
    error,
    vueViewModel,
    lifeCycle,
    url,
    apiEndpoint = null,
    apiData = null
  ) {
    return {
      type,
      user,
      error,
      vueViewModel,
      lifeCycle,
      url,
      apiEndpoint,
      apiData,
      userAgent: navigator.userAgent
    };
  }

  static stringTokenReplace(str, find, replace) {
    if (typeof find !== 'object' && typeof replace !== 'object') {
      return str.replace(find, replace);
    }

    for (var i in find) {
      str = str.replace(find[i], replace[i]);
    }

    return str;
  }

  static replaceInElement(id, find, replace) {
    const $elm = $(id);
    const replaced = this.stringTokenReplace($elm.html(), find, replace);
    return $elm.html(replaced);
  }

  static post(url, data, successCallBack, failCallBack, vm) {
    return axios
      .post(url, data)
      .then((response) => {
        // console.log('post: succes', response);
        successCallBack(response);
      })
      .catch((error) => {
        this.logError(error, vm);
        failCallBack(error);
      });
  }

  static get(url, data, successCallBack, failCallBack, vm) {
    return axios
      .get(url, data)
      .then((response) => {
        // console.log('get: succes', response);
        successCallBack(response);
      })
      .catch((error) => {
        this.logError(error, vm);
        failCallBack(error);
      });
  }

  static all(requests, successCallBack, failCallBack, vm) {
    return axios
      .all(requests)
      .then((response) => {
        // console.log('all: succes', requests);
        successCallBack(response);
      })
      .catch((error) => {
        this.logError(error, vm);
        failCallBack(error);
      });
  }

  static domReady(callBack) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callBack);
    } else {
      callBack();
    }
  }

  static windowReady(callBack) {
    if (document.readyState === 'complete') {
      callBack();
    } else {
      window.addEventListener('load', callBack);
    }
  }

  static pushToTagManager(object) {
    // console.log('pushToTagManager', object);
    if (!window.lbConsentHandeling.hasAllConsent()) {
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(object);
  }

  static getShortPolicyName(fullPolicyName) {
    return this.shortenPolicyName(fullPolicyName.toLowerCase());
  }

  static shortenPolicyName(fullPolicyName) {
    let str;

    switch (fullPolicyName) {
      case 'bilforsikring':
        str = 'bil';
        break;
      case 'campingforsikring':
        str = 'camping';
        break;
      case 'entrepriseforsikring':
        str = 'entreprise';
        break;
      case 'fritidshusforsikring':
        str = 'fritidshus';
        break;
      case 'hundeforsikring':
        str = 'hund';
        break;
      case 'husforsikring':
        str = 'hus';
        break;
      case 'indboforsikring':
        str = 'indbo';
        break;
      case 'knallertforsikring':
        str = 'knallert';
        break;
      case 'lystfartøjsforsikring':
        str = 'lystfartøj';
        break;
      case 'lønsikringsforsikring':
        str = 'lønsikring';
        break;
      case 'motorcykelforsikring':
        str = 'motorcykel';
        break;
      case 'sundhedsforsikring':
        str = 'sundhed';
        break;
      case 'ulykkesforsikring':
        str = 'ulykke';
        break;
      case 'veteranbilforsikring':
        str = 'veteranbil';
        break;
      case 'øvrige køretøjer forsikring':
        str = 'øvrige køretøjer ';
        break;
      default:
        str = null;
        break;
    }

    return str;
  }

  static getDanishTypeName(typeName) {
    let danishTypeName;
    const typeNameToLower = typeName.toLowerCase();
    switch (typeNameToLower) {
      case 'pet':
        danishTypeName = 'hund';
        break;
      case 'content':
        danishTypeName = 'indbo';
        break;
      case 'extended_travel':
        danishTypeName = 'forlænget rejse';
        break;
      case 'caravan_trailer':
        danishTypeName = 'campingvogn';
        break;
      case 'boat':
        danishTypeName = 'lystfartøj';
        break;
      case 'car':
        danishTypeName = 'bil';
        break;
      case 'personal_accident':
        danishTypeName = 'ulykke';
        break;
      case 'moped':
        danishTypeName = 'knallert';
        break;
      case 'motor_cycle':
        danishTypeName = 'motorcykel';
        break;
      case 'vetaran_vehicle':
        danishTypeName = 'veteran';
        break;
      case 'other_vehicles':
        danishTypeName = 'øvrige køretøjer';
        break;
      case 'house':
        danishTypeName = 'hus';
        break;
      case 'vacation_home':
        danishTypeName = 'fritidshus';
        break;
      case 'salary':
        danishTypeName = 'lønsikring';
        break;
      case 'health':
        danishTypeName = 'sundhed';
        break;
      default:
        danishTypeName = '';
    }
    return danishTypeName;
  }

  static getGoogleFriendlyPrice(price) {
    // Check if string
    if (typeof price != 'string') {
      return null;
    }
    // Remove string after space (kr.)
    const noCurrencyPrice = price.split(' ')[0];
    // Strip thousand seperator (period)
    const noThousandSepPrice = noCurrencyPrice.replace(/\./g, '');
    // Replace comma with period as decimal seperator
    const periodSeperatedPrice = noThousandSepPrice.replace(',', '.');

    return periodSeperatedPrice;
  }

  static stickyBasket(selector = '#site-basket') {
    const $sticky = $(selector);

    if ($sticky.offset()) {
      // make sure ".sticky" element exists
      const stickyTop = $sticky.offset().top;
      const stickOffset = 0;
      const width = $sticky.parent().outerWidth();
      const height = $sticky.outerHeight() + 30;
      $sticky.parent().css('height', height);
      $sticky.css('width', width);

      window.addEventListener(
        'scroll',
        this.throttle(() => {
          // scroll event
          var tooSmall = $(window).width() < 1000 ? true : false;
          var windowTop = $(window).scrollTop(); // returns number

          if (stickyTop < windowTop + stickOffset && !tooSmall) {
            $sticky.css({
              position: 'fixed',
              top: stickOffset,
              'z-index': 5
            });
          } else {
            $sticky.css({
              position: 'relative',
              top: 'initial'
            });
          }
        })
      );

      $(window).resize(() => {
        var width = $sticky.parent().outerWidth();
        var height = $sticky.outerHeight() + 30;
        $sticky.parent().css('height', height);
        $sticky.css('width', width);
      });
    }
  }

  static slideToggleAndScroll(e) {
    // Call session keep alive endpoint
    axios.get(Utility.constants().API.keep_alive_session);

    e.preventDefault();
    var offset;
    var targetElement = $(e.currentTarget).parent().parent().parent();
    targetElement.toggleClass('is-active');
    $(e.currentTarget).parent().find('.accordion-content').slideToggle();

    if (targetElement.hasClass('is-active')) {
      if ($('header').hasClass('stuck')) {
        offset = $(window).width() < 1024 ? 53 : 115;
      } else {
        offset = $(window).width() < 1024 ? 100 : 280;
      }

      $('html, body').animate(
        {
          scrollTop: $(e.currentTarget).offset().top - offset
        },
        800
      );
    }
  }

  static attachAppElementIfNone() {
    if (document.getElementById('app') === null) {
      let orgHtml = document.getElementsByTagName('section')[0].innerHTML;
      let newHtml = "<main id='app'>" + orgHtml + '</main>';
      document.getElementsByTagName('section')[0].innerHTML = newHtml;
    }
  }

  static decodeHtml(html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  static scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  static injectTriggerAce() {
    const triggerList = document.querySelectorAll('.ace-trigger');
    let i;

    for (i = 0; i < triggerList.length; i++) {
      triggerList[i].addEventListener('click', () => {
        document.querySelector('.humany-trigger').click();
      });
    }
  }

  static setCookieThatExpiresInParamMinutes(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    const expires = "; expires=" + date.toUTCString();

    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  static getCookieValue(cookieName) {
    return document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)')?.pop() || 'false';
  }

  static deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  static validEmail(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }

  static redirect(url) {
    window.location.href = url;
  }

  static camelizeKeys(obj) {
    if (Array.isArray(obj)) {
      return obj.map((v) => this.camelizeKeys(v));
    }
    if (isPlainObject(obj)) {
      return Object.keys(obj).reduce(
        (result, key) => ({
          ...result,
          [camelCase(key)]: this.camelizeKeys(obj[key])
        }),
        {}
      );
    }
    return obj;
  }

  static formatNumberInDKLocale(num) {
    if (num === undefined) return '';

    const numberFormatter = new Intl.NumberFormat('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return numberFormatter.format(num);
  }

  static formatDateString = (date) => {
    if (!date) return '';

    const d = new Date(date);
    let month = `${d.getMonth() + 1}`,
      day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  static hasScrollbar(element) {
    if (!element) return false;

    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }
}

export { Utility as default };

